<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
      <van-popup
        v-model="loginIntroVisible"
        round
        class="login-intro-popup"
        get-container="body"
        :close-on-click-overlay="false"
      >
        <div class="login-intro-card">
          <div class="login-intro-head">
            <div class="login-intro-title">{{ loginIntroTitle }}</div>
            <button class="login-intro-close" @click="closeLoginIntro">×</button>
          </div>
          <div class="login-intro-divider"></div>
          <div v-if="loginIntroContent" class="login-intro-content">{{ loginIntroContent }}</div>
          <img
            v-if="loginIntroImage"
            :src="loginIntroImage"
            alt="intro"
            class="login-intro-image"
          >
          <div class="login-intro-actions">
            <button class="login-intro-button login-intro-button--confirm" @click="closeLoginIntro">
              {{ loginIntroButtonText }}
            </button>
            <button class="login-intro-button login-intro-button--close" @click="closeLoginIntro">
              {{ loginIntroCloseText }}
            </button>
          </div>
        </div>
      </van-popup>
  </div>
</template>

<script>
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0,
      loginIntroVisible: false,
      loginIntroRequested: false
    };
  },
  computed: {
    baseInfo() {
      return this.$store.getters.getBaseInfo || {};
    },
    loginIntroImage() {
      return this.normalizeAssetUrl(this.baseInfo.login_popup_image);
    },
    loginIntroTitle() {
      return String(this.baseInfo.login_popup_title || '').trim() || 'Latest Announcements';
    },
    loginIntroContent() {
      return String(this.baseInfo.login_popup_content || '').trim();
    },
    loginIntroButtonText() {
      return String(this.baseInfo.login_popup_button_text || '').trim() || 'OK';
    },
    loginIntroCloseText() {
      return String(this.baseInfo.login_popup_close_text || '').trim() || 'Close';
    }
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if (res && res.data) {
          this.$store.commit('setBaseInfoValue', res.data);
          this.tryShowLoginIntro(res.data);
        }
      })
    },
    refreshLoginIntroConfig() {
      this.loginIntroRequested = true;
      this.getBaseInfo();
    },
    normalizeAssetUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      const origin = 'https://admin699.tinlover.com';

      if (/^https?:\/\/127\.0\.0\.1\//.test(url)) {
        return url.replace(/^https?:\/\/127\.0\.0\.1\//, `${origin}/`);
      }

      if (/^https?:\/\/localhost(?::\d+)?\//.test(url)) {
        return url.replace(/^https?:\/\/localhost(?::\d+)?\//, `${origin}/`);
      }

      if (url.startsWith('/')) {
        return `${origin}${url}`;
      }

      return url;
    },
    getLoginIntroStorageKey() {
      const token = localStorage.getItem('token');
      return token ? `login_intro_shown_${token}` : '';
    },
    shouldSkipLoginIntro() {
      const currentPath = this.$route && this.$route.path ? this.$route.path : '';
      return ['/Login', '/Register'].includes(currentPath);
    },
    tryShowLoginIntro(baseInfo) {
      const config = baseInfo || this.baseInfo || {};
      if (!localStorage.getItem('token')) {
        return;
      }
      if (this.shouldSkipLoginIntro()) {
        return;
      }
      if (String(config.login_popup_enabled || '0') !== '1') {
        return;
      }
      if (!String(config.login_popup_title || '').trim() && !String(config.login_popup_content || '').trim() && !String(config.login_popup_image || '').trim()) {
        return;
      }

      const storageKey = this.getLoginIntroStorageKey();
      if (storageKey && sessionStorage.getItem(storageKey) === '1') {
        return;
      }

      this.loginIntroVisible = true;
      sessionStorage.removeItem('login_intro_pending');
      if (storageKey) {
        sessionStorage.setItem(storageKey, '1');
      }
    },
    closeLoginIntro() {
      this.loginIntroVisible = false;
    }

  },
  created(){
    this.getBaseInfo();
  },
  mounted() {
    this.$nextTick(() => {
      this.tryShowLoginIntro();
    });
  },
  watch: {
    '$route.path'() {
      const pending = sessionStorage.getItem('login_intro_pending') === '1';
      if (pending && localStorage.getItem('token') && !this.loginIntroRequested) {
        this.refreshLoginIntroConfig();
      }
      this.tryShowLoginIntro();
    },
    baseInfo: {
      deep: true,
      handler() {
        this.tryShowLoginIntro();
      }
    }
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: linear-gradient(#1d1610, #3b2818) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}

body .login-intro-popup {
  width: calc(100vw - 28px);
  max-width: 760px;
  overflow: visible;
  border-radius: 24px;
  background: transparent;
}

.login-intro-card {
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
}

.login-intro-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 14px 14px;
}

.login-intro-close {
  flex: none;
  width: 34px;
  height: 34px;
  border: 1px solid #8d775f;
  border-radius: 50%;
  background: transparent;
  color: #8d775f;
  font-size: 22px;
  line-height: 30px;
  text-align: center;
}

.login-intro-divider {
  height: 1px;
  margin: 0 14px;
  background: rgba(141, 119, 95, 0.18);
}

.login-intro-image {
  display: block;
  width: calc(100% - 28px);
  margin: 0 14px 18px;
  border-radius: 0;
  object-fit: cover;
}

.login-intro-title {
  color: #dfb07a;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
  text-align: left;
}

.login-intro-content {
  padding: 18px 14px 16px;
  color: #000;
  font-size: 24px;
  line-height: 1.55;
  white-space: pre-line;
  text-align: left;
}

.login-intro-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px;
  padding: 10px 14px 16px;
}

.login-intro-button {
  display: block;
  width: 100%;
  height: 70px;
  border: none;
  border-radius: 999px;
  font-size: 24px;
  font-weight: 800;
}

.login-intro-button--confirm {
  background: #e4ba90;
  color: #6c3a28;
}

.login-intro-button--close {
  background: #17191f;
  color: #fff;
}
</style>
